/** Линейный квиз продажного MVP (15 шагов). */
export const LANDING_QUIZ_ITEMS = [
  {
    id: 'name',
    type: 'text',
    question: 'Как вас зовут?',
    placeholder: 'Имя',
    required: true,
  },
  {
    id: 'phone',
    type: 'phone',
    question: 'Ваш телефон для связи',
    required: true,
  },
  {
    id: 'contact_channel',
    type: 'contact',
    question: 'Как удобнее связаться дополнительно?',
    options: [
      { value: 'telegram', label: 'Telegram' },
      { value: 'email', label: 'E-mail' },
    ],
    required: true,
  },
  {
    id: 'company',
    type: 'text',
    question: 'Название компании',
    placeholder: 'ООО «Пример»',
    required: true,
  },
  {
    id: 'role',
    type: 'choice',
    question: 'Ваша роль в компании',
    options: [
      'Собственник',
      'Руководитель',
      'Тендерный специалист',
      'Коммерческий директор',
      'Другое',
    ],
  },
  {
    id: 'products',
    type: 'textarea',
    question: 'Что ваша компания продаёт или поставляет?',
    placeholder: 'Кратко опишите товары или услуги',
    required: true,
  },
  {
    id: 'tender_interest',
    type: 'textarea',
    question: 'В каких тендерах хотите участвовать?',
    placeholder: 'Направления, тип закупок, примеры',
    required: true,
  },
  {
    id: 'regions',
    type: 'text',
    question: 'Регионы интереса',
    placeholder: 'Например: СПб и ЛО, Москва, вся РФ',
    required: true,
  },
  {
    id: 'procurement_types',
    type: 'multi',
    question: 'Тип закупок',
    options: ['44-ФЗ', '223-ФЗ', 'Коммерческие', 'Не знаю'],
  },
  {
    id: 'tenders_per_month',
    type: 'choice',
    question: 'Сколько тендеров сейчас отслеживаете в месяц?',
    options: ['До 5', '5–20', '20–50', '50–200', 'Более 200'],
  },
  {
    id: 'has_tender_specialist',
    type: 'choice',
    question: 'Есть ли в компании тендерный специалист?',
    options: ['Да, выделенный специалист', 'Частично, совмещают', 'Нет'],
  },
  {
    id: 'current_tools',
    type: 'multi',
    question: 'Как сейчас ищете тендеры?',
    options: [
      'Вручную на площадках',
      'Tenderplan',
      'Seldon',
      'Контур.Закупки',
      'Excel / таблицы',
      'Другое',
    ],
  },
  {
    id: 'main_problem',
    type: 'choice',
    question: 'Главная проблема сейчас',
    options: [
      'Много мусора в выдаче',
      'Долго читать документы',
      'Непонятны шансы на победу',
      'Нет системы отбора',
      'Другое',
    ],
  },
  {
    id: 'needs',
    type: 'multi',
    question: 'Что вам нужно от нас?',
    options: [
      'Ежедневная подборка тендеров',
      'Анализ тендеров и документов',
      'Помощь с настройкой поиска',
      'Сопровождение участия',
      'Всё вместе',
    ],
  },
  {
    id: 'consent',
    type: 'consent',
    question: 'Согласие на обработку персональных данных',
  },
]

export const LANDING_QUIZ_TOTAL = LANDING_QUIZ_ITEMS.length
